module.exports = __webpack_public_path__ + "img/35_28.e74863a4.png";